export default () => ({
  dashboard: {},
  overview: [],
  pagination: {
    currentPage: 1,
    pageSize: 20,
    pageCount: 5,
    totalItems: 0,
  },
  evaluation: {},
  filters: {
    keyword: "",
    advanced: {
      regDates: [],
      roles: [],
      userResponsibilities: [],
    },
  },
  editingUser: {},
});
